module.exports = "https://cdn01.riselinkedu.com/assets/images/title@2x.580ba14.png";